/* eslint-disable react/no-unescaped-entities */
import { Phone, Mail, Instagram, Globe, MapPin } from "lucide-react";
import { BRAND } from "@/lib/divine";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="min-h-screen">
      <section className="pt-16 pb-12 border-b border-black/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="overline mb-6">Get in Touch</div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
            Let's <span className="italic text-[#D4A437]">talk</span>.
          </h1>
          <p className="text-[#6B6B6B] mt-6 max-w-xl">
            Reach out via phone, email or Instagram — we typically respond within a few hours.
          </p>

          {/* Owner / Founder card */}
          <div className="mt-12 border-l-2 border-[#D4A437] pl-6 max-w-xl" data-testid="contact-owner">
            <div className="overline mb-2">Speak directly with</div>
            <div className="font-serif text-3xl md:text-4xl tracking-tight text-[#0A0A0A]">
              {BRAND.owner}
            </div>
            <div className="text-sm text-[#6B6B6B] mt-2">{BRAND.ownerTitle}</div>
            <div className="mt-4 flex flex-wrap gap-3">
              <a href={`tel:${BRAND.phoneRaw}`} className="btn-gold text-xs" data-testid="owner-call">
                <Phone className="w-4 h-4" strokeWidth={1.5} /> Call {BRAND.phone}
              </a>
              <a href={`https://wa.me/${BRAND.phoneRaw.replace('+','')}`} target="_blank" rel="noreferrer" className="btn-ghost text-xs" data-testid="owner-whatsapp">
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-6">
          <ContactCard icon={Phone} label="Call Us" value={BRAND.phone} href={`tel:${BRAND.phoneRaw}`} testId="contact-phone" />
          <ContactCard icon={Mail} label="Email" value={BRAND.email} href={`mailto:${BRAND.email}`} testId="contact-email" />
          <ContactCard icon={Instagram} label="Instagram" value={`@${BRAND.instagram}`} href={BRAND.instagramUrl} testId="contact-instagram" />
          <ContactCard icon={Globe} label="Website" value={BRAND.website} href={`https://${BRAND.website}`} testId="contact-website" />
        </div>
      </section>

      <section className="py-20 border-t border-black/5 mandala-bg">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <MapPin className="w-8 h-8 text-[#D4A437] mx-auto mb-6" strokeWidth={1.3} />
          <h2 className="font-serif text-3xl md:text-4xl">Studio Visits by Appointment</h2>
          <p className="text-[#6B6B6B] mt-4">
            We work across India. To schedule a visit, please book a consultation or call us directly.
          </p>
        </div>
      </section>
    </div>
  );
}

function ContactCard({ icon: Icon, label, value, href, testId }) {
  return (
    <a
      href={href}
      data-testid={testId}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel="noreferrer"
      className="group border border-black/10 bg-[#FAF7F0] p-10 hover:border-[#D4A437]/60 transition-all duration-300"
    >
      <Icon className="w-7 h-7 text-[#D4A437] mb-6" strokeWidth={1.3} />
      <div className="overline mb-2">{label}</div>
      <div className="font-serif text-2xl md:text-3xl text-[#0A0A0A] group-hover:text-[#D4A437] transition-colors">
        {value}
      </div>
    </a>
  );
}
